import React from 'react'
import ModalBody from "../modalbody";
import { CouponList } from '../Offers/offer';
import CheckCouponInput from '../Offers/checkoffer';

const OffersModal = () => {
    return (
        <ModalBody heading="">
            <div style={{minHeight: `260px`}}>
                <div className="flex-center">
                    <h3 className="f-600 header-underline text-center">Apply Coupon</h3>
                </div>
                <div className="container m-t-10">
                    <div>
                        <CheckCouponInput />   
                    </div>
                    <div className="row" style={{maxHeight: `360px`, overflow: 'auto'}}>
                        <CouponList />
                    </div>
                </div>
            </div>
        </ModalBody>
    )
}

export default OffersModal
